import request from '@a/js/request'

// 获取自定义页面配置信息
export function GetCustomOptions(query) {
  return request({
    url: '/c/website/v1/custom',
    method: 'get',
    params: query,
  })
}
